/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Logo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconLogo from 'DesignSystem/Svgs/TysiaIconLogo/index'



/** @type {import('Simple/types.js').View} */
export default function Logo({
  children,
  viewPath = "/App/Account/Topbar/Logo"
  
}) {
let authAccessTokenDataIsSupportValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<TysiaIconLogo
  viewPath={`${viewPath}/TysiaIconLogo`}
 width={32}
 height={32}
 fill={authAccessTokenDataIsSupportValueData ? dtColorsNeutral200 : "#00BC70"}
 data="auth.access_token_data.is_support"
/>
{children}
</React.Fragment>)
}